export default {
    actions: {
        usaToolsBtn: 'מיון חו"ל',
    },
}
